<script>
    import DeleteIcon from 'vue-material-design-icons/Delete.vue';
    import vToggle from 'v-toggle';
    // https://www.npmjs.com/package/v-toggle?activeTab=readme

    export default {
      components: {
          DeleteIcon,
          vToggle,
        },
        props: ['user', 'filterAdmins'],
        data() {
            return {
                showDesc: false,
            }
        },
        methods: {   
          toggleApproval( user, event ) {
            this.$emit( 'toggleApproval', user, event )
          },
          deleteUser( user ) {
            this.$emit( 'deleteUser', user )
          }
        }     
    }
</script>



<template lang="pug">


.user_detail_block
  .nameHeader
    a(:href="'mailto:' + user.email" v-if="user.first" target="_blank") {{user.first}} {{user.last}} 
    a(:href="'mailto:' + user.email" target="_blank" v-else) {{user.email}}
    span.admin(v-if="user.admin")
      img(src="@/assets/crown.png") 
  .row
    .col.s12
      router-link(:to="'/industry/viewEducator/' + user.uid" v-if="user.type == 'Educator'") View profile
      router-link(:to="'/educator/viewIndustry/' + user.uid" v-else ) View profile      
  .created
      .row 
        .col.s12.user_name 
          label Registered: 
          span {{user.created}}                
  .details( v-if="user.institution || user.eduRecord || user.companyRecord ")
    .foo.details-section( v-if="user.type == 'Educator' && user.eduRecord")
      .row 
        .col.s12.user_name 
          label Email: 
          span {{user.email}}
      .row 
        .col.s12.user_name 
          label Name: 
          span {{user.fName}} {{user.lName}} 
      .row 
        .col.s12.user_name 
          label Phone: 
          span {{user.phone}} 
      .row 
        .col.s12.user_name 
          label School: 
          span {{user.school}}     

    .foo.details-section( v-if="user.type == 'Company' && user.companyRecord")
      .row 
        .col.s12.user_name 
          label Email: 
          span {{user.email}}   
      .row 
        .col.s12.user_name 
          label Name: 
          span {{user.name}}  
      .row 
        .col.s12.user_name 
          label Phone: 
          span {{user.phone}} 

    .foo( v-if="user.institution")      
      .row 
        .col.s12.user_name 
          label Email: 
          span {{user.email}}      
      .row 
        .col.s12.user_name
          label Company: 
          span {{user.institution}}
      .row 
        .col.s12.user_desc
          label Purpose: 
          span {{user.description}}  
  .details(v-else)
    p Profile not updated
  .row
    .col.s12
      label Approved?
      .approval-container
        v-toggle.foo( 
          :id="user.uid" 
          :width="40"
          :height="20"
          v-model="user.approved" 
          v-on:click.native="toggleApproval(user, $event)" 
          active-color="#008000"
          inactive-color="#aa483c") 
  .row
    .col.s12
      span.delete_user(@click="deleteUser(user)") Delete User 



</template>



<style lang="sass" scoped>

.details-section
  .row
    padding-bottom: 5px !important

span.delete_user
  color: red
  cursor: pointer 

span.delete_user:hover
  color: darkRed  

.nameHeader
  font-size: 1.5em
  padding-bottom: 5px

.user_detail_block
  border: thin solid gray
  border-radius: 5px
  padding: 5px
  margin-left: 10px
  -webkit-box-shadow: -5px 5px 15px -2px rgba(0,0,0,0.5); 
  box-shadow: -5px 5px 15px -2px rgba(0,0,0,0.5);  

label
  font-size: 1em
  display: block
  float: left
  width: 100px

.user_detail_block
  padding-left: 10px

td.delete-container, td.approval-container, .centered
  

.admin
  position: relative;
  top: 15px;
  img 
    height: 30px;
    position: relative;
    top: -10px;

.delete-user
  font-size: 2.5em
  cursor: pointer

.delete-user:hover
  color: red  

</style>